/** Replaces Ionic's LoadingController overlay. */
export function PageSpinner({ message = 'Loading...' }: { message?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-64 flex-col items-center justify-center gap-3 py-16 text-slate-600"
    >
      <span className="size-8 animate-spin rounded-full border-2 border-slate-300 border-t-primary motion-reduce:animate-none" />
      <span className="text-sm">{message}</span>
    </div>
  );
}
